// IssueTrackerInterface.js
export class IssueTrackerInterface {
    constructor(config) {
        this.config = config;
    }

    // eslint-disable-next-line no-unused-vars
    async createIssue(issue) {
        throw new Error("createIssue method must be implemented by subclass");
    }

    // eslint-disable-next-line no-unused-vars
    async getIssueUrl(issueKey) {
        throw new Error("getIssueUrl method must be implemented by subclass");
    }

    // eslint-disable-next-line no-unused-vars
    async deleteIssue(issueKey) {
        throw new Error("deleteIssue method must be implemented by subclass");
    }

    // eslint-disable-next-line no-unused-vars
    async getIssue(issueKey) {
        throw new Error("getIssue method must be implemented by subclass");
    }

    // eslint-disable-next-line no-unused-vars
    async updateIssue(trackerKey, issue) {
        throw new Error("updateIssue method must be implemented by subclass");
    }

    async getAssignees() {
        throw new Error("getAssignees method must be implemented by subclass");
    }

    async getParentIssues() {
        throw new Error("getParentIssues method must be implemented by subclass");
    }
}